export default __webpack_public_path__ + "static/media/Svetozar Georgiev.db270666.png";